export enum ResinSource {
  ds = 1,
  rwc = 2,
}
